<template>
  <v-main>
    <BaseCrudTable ref="basetable"
                   :headers="headers"
                   @editClicked="editClick"
                   table-name="Заболевание"
                   endpoint="diseasestype"
                   label="Заболевание">
      <template v-slot:editVals>
        <v-col>
          <div ref="form">
            <v-card-text>
              <v-text-field
                ref="name"
                v-model.trim="editItem.name"
                :rules="[() => !!editItem.name || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Имя"
                placeholder="Введите имя"
                required />
            </v-card-text>
            <v-card-actions>
              <v-btn @click="close()" text>
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn @click="submit" color="primary" text>
                Подтвердить
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </template>
    </BaseCrudTable>
  </v-main>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'

export default {
  name: "DiseaseTypesTable",
  components: {BaseCrudTable},
  data () {
    return {
      headers: [
        {text: 'id', value: 'id', align: 'left', class:['d-none']},
        {text: 'Название', value: 'name', align: 'left'},
        {text: 'Действия', value: '', align: 'left'}
      ],
      editItem: {
        name: '',
        id: ''
      },
      dialog: false,
      errorMessages: '',
      formHasErrors: false
    }
  },
  computed: {
    form () {
      return {
        name: this.editItem.name
      }
    }
  },
  methods: {
    editClick (newVal) {
      this.simpleEditClick(newVal)
    },
    submit () {
      this.formSubmit()
      this.$store.dispatch("tableData/loadDiseaseTypes")

    },
    close () {
      this.$refs["basetable"].close()
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/DiseaseTypesTable.vue